import { apiGet, apiPost } from "./client";

export const authApi = {
  me: () => apiGet("/api/auth/me"),
  login: (email, password) =>
    apiPost("/api/auth/login", { email, password }),
  logout: () => apiPost("/api/auth/logout"),
};
